var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ta-lot-social-shares-popup"},[_c('button',{staticClass:"btn btn-link ta-lot-social-shares-button"},[_c('b-icon',{attrs:{"icon":"reply-fill"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }